module.exports = __webpack_public_path__ + "static/media/instagram.cdb3118b.svg";